import {
  Paper,
  Title,
  Text,
  TextInput,
  Button,
  Container,
  Group,
  Anchor,
  Center,
  Box,
  createStyles,
} from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons";
import { message } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageTitle } from "../../components";
import { postForgotPassword } from "../../helpers/api";
import { authenticate, setRole } from "../../helpers/auth";
import { appLinks } from "../../helpers/config";
import { openNotification } from "../../helpers/utilities";

const useStyles = createStyles((theme) => ({
  title: {
    fontSize: 26,
    fontWeight: 900,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
  },

  controls: {
    [theme.fn.smallerThan("xs")]: {
      flexDirection: "column-reverse",
    },
  },

  control: {
    [theme.fn.smallerThan("xs")]: {
      width: "100%",
      textAlign: "center",
    },
  },
}));

export function ForgotPasswordPage() {
  const { classes } = useStyles();
  const [state, setSate] = useState({
    email: "",
  });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!state.email) {
      message.info("Please provide your email address");
      return;
    }

    setBusy(true);

    postForgotPassword(state)
      .then((res) => {
        if (res.status === 200) {
          message.success("Please check your inbox for instructions");
          setTimeout(() => {
            nav(appLinks.login);
          }, 1500);
        } else throw res;
      })
      .catch((ex) => {
        message.error(
          ex.response.data.message || "Something went wrong. Contact Admin"
        );
        setBusy(false);
      });
  };

  return (
    <Container size={460} my={30}>
      <PageTitle title="Forgot Password" />
      <Title className={classes.title} align="center">
        Forgot/Reset your password
      </Title>
      <Text color="dimmed" size="sm" align="center">
        Enter your email for instructions
      </Text>
      <form onSubmit={handleSubmit} method="POST">
        <Paper withBorder shadow="md" p={30} radius="md" mt="xl">
          <TextInput
            onChange={(e) => setSate({ email: e.target.value })}
            value={state.email}
            label="Your email"
            placeholder="you@mail.com"
            required
            size="md"
          />
          <Group position="apart" mt="lg" className={classes.controls}>
            <Anchor
              color="dimmed"
              size="sm"
              className={classes.control}
              onClick={() => nav(appLinks.login)}>
              <Center inline>
                <IconArrowLeft size={12} stroke={1.5} />
                <Box ml={5}>Back to Login</Box>
              </Center>
            </Anchor>
            <Button
              type="submit"
              className={`app-btn btn-prim ${classes.control}`}
              loading={busy}>
              Reset password
            </Button>
          </Group>
        </Paper>
      </form>
    </Container>
  );
}
